import { Link } from 'react-router-dom';
import SeoHead from '@/components/SeoHead';

export default function NotFoundPage() {
  return (
    <main className="min-h-screen bg-surface px-6 py-24 flex items-center justify-center">
      <SeoHead title="Page Not Found | JOBFITAI" canonicalPath="/404" robots="noindex,follow" />
      <section className="max-w-lg text-center">
        <p className="text-sm font-semibold text-primary mb-3">404</p>
        <h1 className="font-heading text-3xl font-bold text-foreground mb-4">Page not found</h1>
        <p className="text-muted-foreground mb-8">
          The page you requested is not available or may have moved.
        </p>
        <Link
          to="/"
          className="inline-flex items-center justify-center bg-primary text-white px-6 py-3 rounded-lg font-medium hover:bg-primary-hover transition-colors"
        >
          Return to homepage
        </Link>
      </section>
    </main>
  );
}
